import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeTypeBilling'
})
export class PipeTypeBilling implements PipeTransform {
    transform(type) {
        if(type == '1'){
            return 'VMR Fixa';
        }else if(type == '2'){
            return 'VMR Concorrentes';
        }else if(type == '3'){
            return 'Chamadas Concorrentes';
        }else{
            return 'Modelo Comercial';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeTypeBilling.ts